var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:('min-height: ' + _vm.height + '; height: 1px;'),attrs:{"id":"vertical-align"}},[_c('div',{staticClass:"h-100 w-100 d-table"},[_c('div',{staticClass:"d-table-cell align-middle"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }